import {PalettePrimary, SheetProps, Theme} from "@mui/joy";
import {ReactNode} from "react";

export interface TileColors {
    mainForeground: string;
    mainBackground: string;
    border: string;
    subjectForeground: string;
    subjectBackground: string;
}

export function figureColors(
    {
        theme,
        color: inColor,
        invertedColors,
        variant: inVariant
    }: (Partial<SheetProps> & {theme: Theme})) {
    const paletteName = inColor ?? "neutral";
    const palette = theme.palette[paletteName];
    const variant = inVariant ?? "soft";
    const fgShade = `${variant}${invertedColors ? "Bg" : "Color"}` as (keyof PalettePrimary);
    const bgShade = `${variant}${invertedColors ? "Color" : "Bg"}` as (keyof PalettePrimary);
    const fgColor = palette[fgShade];
     
    const bgColor = palette[bgShade];
    const border = palette[800];
    const subjectFg = palette[800];
    const subjectBg = palette[50];
    return {
        mainForeground: fgColor,
        mainBackground: bgColor,
        border,
        subjectForeground: subjectFg,
        subjectBackground: subjectBg,
    };
}

export function figureChildVariant(oyaVariant: SheetProps["variant"]): SheetProps["variant"] {
    const rv = oyaVariant === "outlined" ? "plain" : oyaVariant;
    return rv;
}

export interface ColoredContent {
    color: SheetProps["color"];
    content: ReactNode;
}